import fetch from '../utils/fetch'
export function getUser (query) {
  return fetch({
    url: '/baoxian/getlist',
    method: 'get',
    params: query
  })
}

export function getOrder (query) {
  return fetch({
    url: '/baoxian/getOrderList',
    method: 'get',
    params: query
  })
}

export function passData (orderId) {
  return fetch({
    url: '/baoxian/passData',
    method: 'get',
    params: orderId
  })
}

export function sendData (orderId) {
  return fetch({
    url: '/baoxian/sendData',
    method: 'get',
    params: orderId
  })
}
export function sendEmployee (orderId) {
  return fetch({
    url: '/baoxian/sendToEmployee',
    method: 'get',
    params: orderId
  })
}

export function getOrderData (query) {
  return fetch({
    url: '/baoxian/export',
    method: 'get',
    params: query
  })
}

export function updateEmployee (query) {
  return fetch({
    url: '/baoxian/updateEmployee',
    method: 'put',
    data: query
  })
}

export function pullOrder (query) {
  return fetch({
    url: '/baoxian/pullOrder',
    method: 'put',
    data: query
  })
}
export function isTrial (orderId) {
  return fetch({
    url: '/baoxian/isTrial',
    method: 'get',
    params: orderId
  })
}

export function saveInvoice (query) {
  return fetch({
    url: '/baoxian/saveInvoice',
    method: 'put',
    data: query
  })
}

export function ZhonganUserCard (query) {
  return fetch({
    url: '/baoxian/Zhongan_user_card',
    method: 'get',
    params: query
  })
}
export function getFinancialReconciliation (query) {
  return fetch({
    url: '/baoxian/getFinancialReconciliation',
    method: 'get',
    params: query
  })
}

export function ZhonganUserCardExport (query) {
  return fetch({
    url: '/baoxian/ZhonganUserCardExport',
    method: 'get',
    params: query
  })
}
export function getFinancialReconciliationExport (query) {
  return fetch({
    url: '/baoxian/getFinancialReconciliationExport',
    method: 'get',
    params: query
  })
}
export function RenbaoList (query) {
  return fetch({
    url: '/baoxian/RenbaoList',
    method: 'get',
    params: query
  })
}
export function RenbaoExport (query) {
  return fetch({
    url: '/baoxian/RenbaoExport',
    method: 'get',
    params: query
  })
}
export function QmbaoList (query) {
  return fetch({
    url: '/baoxian/qmbaoList',
    method: 'get',
    params: query
  })
}
export function QmbaoExport (query) {
  return fetch({
    url: '/baoxian/qmbaoExport',
    method: 'get',
    params: query
  })
}
export function SdbaoList (query) {
  return fetch({
    url: '/baoxian/sdbaoList',
    method: 'get',
    params: query
  })
}
export function SdbaoExport (query) {
  return fetch({
    url: '/baoxian/sdbaoExport',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/baoxian.js